<template>
    <Transition v-if="isLoading" name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>PROTO</span>
            </span>
        </div>
    </Transition>

    <v-form :name="formProps.formName"
            @keyup.enter="autoSave = false">
        <Tabs value="0"
              scrollable>

            <TabList>
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="provider_name"
                                       label="Provider name"
                                       size="10"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       :isFocus="true"
                                       v-model:field="crud.provider_name" />

                        <FormInputText fieldName="symbol"
                                       label="Symbol"
                                       size="2"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.symbol" />

                        <FormInputText fieldName="full_name"
                                       label="KRS name"
                                       size="12"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.full_name" />

                        <FormInputText fieldName="street"
                                       label="Street"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.street" />

                        <FormInputText fieldName="zip"
                                       label="Postal code"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.zip" />

                        <FormInputText fieldName="town"
                                       label="Town"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.town" />

                        <FormInputText fieldName="NIP"
                                       label="NIP"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.NIP" />

                    </div>
                </TabPanel>
                <TabPanel v-if="crud.log"
                          value="1">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled"
                         v-model:autoSave="autoSave">
            </FormButtons>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { validation, initForm } from '@pages/Helper/crud_utils.js'
import FormInputText from '@crud/FormInputText.vue'
import FormButtons from '@crud/FormButtons.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import { __ } from '@pages/Helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(false)
const autoSave = ref(false)
const buttonsVisibility = ref(null);

const crud = ref({})

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, null, null, buttonsVisibility)
})

// -----------------------------------------------------


</script>

<style lang="scss" scoped></style>
